import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingAnimationComponent } from './components/loading-animation/loading-animation.component';
import { LoadingAnimationNetworkComponent } from './components/loading-animation-network/loading-animation-network.component';
import { RouterModule } from '@angular/router';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { BackToNavigationBarComponent } from './components/back-to-navigation-bar/back-to-navigation-bar.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { MobileRegisterSignInBarComponent } from './components/mobile-register-sign-in-bar/mobile-register-sign-in-bar.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderModule } from './features/header/header.module';
import { FooterNavigationComponent } from './components/footer-navigation/footer-navigation.component';
import { DontSanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { ModalConfirmationComponent } from './components/modal-confirmation/modal-confirmation.component';
import { ModalWithContentComponent } from './components/modal-with-content/modal-with-content.component';
import { BlockquoteImageComponent } from './components/blockquote-image/blockquote-image.component';
import { InputWithDoneButtonComponent } from './components/input-with-done-button/input-with-done-button.component';
import { TextToSpeechModule } from './features/text-to-speech/text-to-speech.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ResendVerificationCodeComponent } from './components/resend-verification-code/resend-verification-code.component';

@NgModule({
  imports: [
    CommonModule, 
    RouterModule, 
    ReactiveFormsModule,
    LoadingAnimationNetworkComponent,
    DontSanitizeHtmlPipe
  ],
  declarations: [
    LoadingAnimationComponent,
    BreadcrumbsComponent,
    BackToNavigationBarComponent,
    ProgressBarComponent,
    MobileRegisterSignInBarComponent,
    FooterComponent,
    FooterNavigationComponent,
    ModalConfirmationComponent,
    ModalWithContentComponent,
    BlockquoteImageComponent,
    InputWithDoneButtonComponent,
    ResendVerificationCodeComponent
  ],
  exports: [
    HeaderModule,
    LoadingAnimationComponent,
    BreadcrumbsComponent,
    BackToNavigationBarComponent,
    ProgressBarComponent,
    MobileRegisterSignInBarComponent,
    FooterComponent,
    FooterNavigationComponent,
    ModalConfirmationComponent,
    ModalWithContentComponent,
    BlockquoteImageComponent,
    InputWithDoneButtonComponent,
    TextToSpeechModule,
    ResendVerificationCodeComponent
  ],
})
export class MonoCommonModule {}
